import React from 'react'
import { Box, CircularProgress, Dialog, Typography } from '@mui/material'

interface ICircularLoadingProps {
  isLoading?: boolean
  message?: string
}

const CircularLoading = (props: ICircularLoadingProps) => {
  const { isLoading = false, message = '' } = props
  return (
    <>
      <Dialog open={isLoading}>
        <React.Fragment>
          <Box textAlign={'center'} p={4}>
            <CircularProgress />
            <Typography sx={{ my: 2 }} variant="h6">{message ? message : 'กำลังโหลดข้อมูล...'}</Typography>
          </Box>
        </React.Fragment>
      </Dialog>
    </>
  )
}

export default CircularLoading
